/** Shared amber offline banners for workspace list pages */
export const workspaceOfflineBannerStyles = `
.sup2-alert--offline,.sal2-err--offline,.exp-error--offline,.pur2-err--offline{
  background:#fffbeb!important;border-color:#fde68a!important;color:#92400e!important
}
`;
